import links from '@utils/externalLinks';
import * as React from 'react';
export default {
  links,
  React
};